import { RelatedDocument } from '@asset-metrix/portal-gateway-client-js';
import { TFunction } from 'i18next';

import { ButtonProps } from '../buttons/Button';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';
import { SVGIcon } from '../icons/SVGIcon';

type BuildSidebarDocumentActionButtonsParams = {
  documents?: RelatedDocument[];
  onDocumentDownload?: () => void;
  onOpenInPage?: ButtonProps['onClick'];
  openInPageButtonText?: string;
  selectedDocument?: RelatedDocument;
  t: TFunction;
};

export function buildSidebarDocumentActionButtons({
  documents,
  onDocumentDownload,
  onOpenInPage,
  openInPageButtonText,
  selectedDocument,
  t,
}: BuildSidebarDocumentActionButtonsParams): ButtonProps[] {
  const buttons: ButtonProps[] = [];

  if (onOpenInPage) {
    buttons.push({
      variant: 'secondary',
      icon: <GoogleFontIcon name="open_in_new" />,
      onClick: onOpenInPage,
      title: openInPageButtonText ?? t('app.pageSidebar.openInPage'),
      disabled: !documents || documents.length === 0,
    });
  }

  if (onDocumentDownload) {
    buttons.push({
      variant: 'primary',
      icon: <SVGIcon name="download" />,
      onClick: onDocumentDownload,
      title: t('app.pageSidebar.download'),
      disabled: !selectedDocument || selectedDocument.virusFree === false,
    });
  }

  return buttons;
}
